//crypto.js文件内容
import CryptoJS from 'crypto-js'
import config from './config.js'
/**
 * @description: 加密
 * @param {*} word
 */
function set(word) {
  // let keyStr =  'gbcdeg0922456789' // 16位的密钥，自己定义，和下面的密钥要相同
  let keyStr = config.keyStr
  var srcs = CryptoJS.enc.Utf8.parse(word) //  字符串到数组转换，解析明文
  var key = CryptoJS.enc.Utf8.parse(keyStr) //  字符串到数组转换，解析秘钥
  // mode:加密方式；padding:填充方式；iv便宜向量（可选）
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString() // 加密后的结果是对象，要转换为文本
}

/**
 * @description: 解密
 * @param {*} word
 */
function get(word) {
  let keyStr = config.keyStr
  var key = CryptoJS.enc.Utf8.parse(keyStr) //  字符串到数组转换
  var decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString() //  数组到字符串转换
}

function isPhone(value) {
  var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
  if (!phonereg.test(value)) {
    return false
  } else {
    return Number(value)
  }
}

function isNumber(value) {
  let num = Number(value)
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(num)

}

function isImage(val) {
  let state = false;
  let arr = ['.png', '.jpg', '.jpeg', '.gif', '.avi', '.mpeg', '.mpg', '.rmvb', '.mp4', '.dat', '.mav', '.mp3', '.asp', '.au', '.midi'];
  for (let i = 0; i < arr.length; i++) {
    if (val.indexOf(arr[i]) > -1) {
      state = true;
    }
  }
  return state
}

function uuid() {
  let s = [];
  let hexDigits = config.hexDigits;
  for (let i = 0; i < 32; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

  let uuid = s.join("");
  return uuid;
}

/**
 * 生成指定位数的uuid
 * @param {*} num 
 * @returns 
 */
function uuidNum(num = 10) {
  let s = [];
  let hexDigits = config.hexDigits;
  for (let i = 0; i < num; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 10), 1);
  }

  let uuid = s.join("");
  return uuid;
}

// 判断是否是手机端
function isPCMobile() {
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
}

// 判断是否是微信
function isWechat() {
  let ua = navigator.userAgent.toLowerCase();
  let isWeixin = ua.indexOf("micromessenger") != -1;
  if (isWeixin) {
    return true;
  } else {
    return false;
  }
}

export {
  set,
  get,
  isPhone,
  isNumber,
  isImage,
  uuid,
  uuidNum,
  isPCMobile,
  isWechat,
}